import axios from 'axios';
const hostPath = process.env.REACT_APP_API_BASE_URL;
const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
export const fetchUserDetails = async (EntityRegistrationID) => {
    try {
        const response = await fetch(`${hostPath}/api/GetUserDetailsbyid`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EntityRegistrationID }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const checkEmailExistence = async (email) => {
    const emailid = { EmailId: email };

    try {
        const response = await axios.post(
            `${hostPath}/api/CheckEmailIdExist`,
            emailid
        );

        if (response.data === true) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
        return false;  // Optionally return false or handle the error as needed
    }
};
export const checkMobileExistence = async (phoneNumber) => {
    const mobileNumber = { MobileNumber: phoneNumber };
    try {
        const response = await axios.post(
            `${hostPath}/api/CheckMobileExist`,
            mobileNumber
        );
        if (response.data === true) {
            return true;
        } else {
            return false;
        }
    }
    catch (error) {
        console.error("Error", error);
        return false;
    }
}
export const fetchUserDetailsByEmpId = async (EmpId) => {
    try {
        const response = await fetch(`${hostPath}/api/GetUserDetailsbyEmpId`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EmpId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const deleteUserByEmail = async (email,userid) => {
    const deleteJson = (userid != null) ? { EmailId: email.toLowerCase(), UserId: userid } : { EmailId: email.toLowerCase() };  // Ensure email is lowercase
    try {
        const response = await axios.post(
            `${hostPath}/api/DeleteUserBasedOnEmailId`, 
            deleteJson,
            {
                headers: { "x-functions-key": `${hostHeader}` },
            }
        );
        if (response.data) {
            // Handle the status of the response
            if (response.data.status) {
                return { success: true, message: 'User has been deleted successfully!' };
            } else {
                return { success: false, message: response.data.responseMessage };
            }
        } else {
            return { success: false, message: 'No response from the server. Please try again.' };
        }
    } catch (error) {
        console.error('Error during user deletion:', error);
        throw new Error('Failed to delete user. Please try again later.');
    }
};
export const sendTemppassword = async (reqbody) => {
    try {
        const response = await axios.post(
            `${hostPath}/api/SendTemporaryPasswordEmail`,
            reqbody,
            { headers: { "x-functions-key": `${hostHeader}` } }
        );
        if (response.data.status === "success") {
            return response.data.temporaryPassword;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
        return false; 
    }
};
const withNormalizedEmailId = (reqbody = {}) => ({
    ...reqbody,
    ...(reqbody.EmailId != null && {
        EmailId: String(reqbody.EmailId).trim().toLowerCase(),
    }),
});

export const entityRegistration = async (reqbody) => {
    try {
        const response = await axios.post(
            `${hostPath}/api/entityregistration`,
            withNormalizedEmailId(reqbody),
            { headers: { "x-functions-key": `${hostHeader}` } }
        );
        if (response.data.status) {
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
        return false; 
    }
};
export const fetchUserDetailsByEmailId= async (EmailId) => {
    try {
        const response = await fetch(`${hostPath}/api/GetUserDetails`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EmailId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const UpdateProfile = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/updateuserdetails`, {
          method: "PUT",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};
export const UpdateProfileByEntity = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/UpdateUserDetailsByEntityid`, {
          method: "PUT",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(withNormalizedEmailId(reqbody)),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};

export const UpdateOwnerVideoUrl = async (email, videoUrl, videofileName) => {
    try {
        const response = await fetch(`${hostPath}/api/updateVideoUrl`, {
            method: "PUT",
            headers: {
                "x-functions-key": `${hostHeader}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, videoUrl, videofileName }),
        });
        // Get the response text first
        const text = await response.text();
        let data = null;
        try {
            // Try parsing only if it's valid JSON
            data = text ? JSON.parse(text) : null;
        } catch (parseError) {
            console.warn("Response is not JSON, raw response:", text);
        }
        if (!response.ok) {
            throw new Error(data?.ResponseMessage || text || "Network response was not ok");
        }

        return data;
    } catch (error) {
        console.error("Failed to update video URL:", error);
        throw error;
    }
};


export const UpdatePassword = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/ForgetPassword`, {
          method: "POST",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};

export const fetchUsersWithValidEmpId = async () => {
    try {
        const response = await fetch(`${hostPath}/api/GetUsersWithValidEmpId`, {
            method: "GET",
            headers: {
                "x-functions-key": `${hostHeader}`,
                "Content-Type": "application/json",
              },
            redirect: "follow"
        });

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error('Unauthorized: You do not have permission to access this resource.');
            } else {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }  
        }
        const data = await response.json(); // Use .json() for JSON response
        return data;  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch users with valid employee IDs:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const checkTemppassword = async (email) => {
    const emailid = { EmailId: email };
    const requestOptions = {
        method: "POST",
        headers: { "x-functions-key": `${hostHeader}` },
        body: JSON.stringify(emailid),
    };
    try {
        const response = await axios.post(
            `${hostPath}/api/CheckTempPassword`,
            requestOptions.body,
            { headers: requestOptions.headers }
        );
        if (response.data?.message?.includes("true")) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
    }
}
export const checkTempcreds = async (email,password) => {
    const emailid = { EmailId: email,TempPassword:password };
    const requestOptions = {
        method: "POST",
        headers: { "x-functions-key": `${hostHeader}` },
        body: JSON.stringify(emailid),
    };
    try {
        const response = await axios.post(
            `${hostPath}/api/ValidateTempcredentials`,
             requestOptions.body,
            { headers: requestOptions.headers }
        );
        if (response.data.status === true) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
    }
}
export const GetOwnerDetailsFromToken = async () => {
    try {
        const response = await fetch(`${hostPath}/api/GetOwnerDetailsFromToken`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
              },
            redirect: "follow"
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json(); // Use .json() for JSON response
        return data;  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch users with valid employee IDs:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const fetchUserDetailsByUserId = async (UserId) => {
    try {
        const response = await fetch(`${hostPath}/api/GetUserDetailsbyuserid`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ UserId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log("user data response",data);
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const OwnerRegistrationB2C = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/CreateUser`, {
          method: "POST",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};

export const deleteUserByUserID = async (userId) => {
    try {
        const response = await axios.post(
            `${hostPath}/api/DeleteUser`,
            { UserId: userId },
            { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.status === 204) {
            console.log('User deleted successfully.');
            return true;
        } else {
            console.warn(`Unexpected response: ${response.status} - ${response.data}`);
            return false;
        }
    } catch (error) {
        if (error.response) {
            console.error(`API Error (${error.response.status}): ${error.response.data}`);
            return { success: false, message: `API Error: ${error.response.data}` };
        } else {
            console.error('Error during user deletion:', error.message);
            return { success: false, message: 'Failed to delete user. Please try again later.' };
        }
    }
};

export const fetchLinkedAccounts = async () => {
    try {
        const response = await fetch(`${hostPath}/api/GetLinkedAccounts`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
            }
        })
        const data = await response.json();
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return data;
    }
    catch (error) {
        if (error.response) {
            console.error(`API Error (${error.response.status}): ${error.response.data}`);
            return { success: false, message: `API Error: ${error.response.data}` };
        } else {
            console.error('Error updating user display name:', error.message);
            return { success: false, message: 'Failed to update user display name. Please try again later.' };
        }
    }
}

export const updateUserDisplayName = async (userId, firstName, lastName) => {
    try {
        const response = await axios.post(
            `${hostPath}/api/UpdateUserDisplayNameB2C`,
            { UserId: userId, FirstName: firstName, LastName: lastName },
            { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.status === 200) {
            console.log('User display name updated successfully.');
            return { success: true, message: 'User display name updated successfully.' };
        } else {
            console.warn(`Unexpected response: ${response.status} - ${response.data}`);
            return { success: false, message: `Unexpected response: ${response.data}` };
        }
    } catch (error) {
        if (error.response) {
            console.error(`API Error (${error.response.status}): ${error.response.data}`);
            return { success: false, message: `API Error: ${error.response.data}` };
        } else {
            console.error('Error updating user display name:', error.message);
            return { success: false, message: 'Failed to update user display name. Please try again later.' };
        }
    }
};

// Owner Dashboard API Calls
    export const fetchAllPSLData = async (EntityRegistrationID) => {
        try {
            const response = await fetch(`${hostPath}/api/GetAllParkingLotData`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": hostHeader,
                },
                body: JSON.stringify({ EntityRegistrationID }),
            });

            if (!response.ok) {
                throw new Error("Failed to fetch lot summary");
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching parking lot data:", error);
            throw error;
        }
    };

    export const fetchOwnerEarnings = async (EntityRegistrationID) => {
        try {
            const response = await fetch(`${hostPath}/api/GetOwnerEarnings`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": hostHeader,
                },
                body: JSON.stringify({ EntityRegistrationID }),
            });

            if (!response.ok) {
                throw new Error("Failed to fetch earnings");
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching earnings:", error);
            throw error;
        }
    };

    export const fetchParkingOverview = async (EntityRegistrationID, lotId = "All") => {
        try {
            let body = { EntityRegistrationID };

            if (lotId !== "All") {
                body.ParkingLotId = parseInt(lotId);
            }

            const response = await fetch(`${hostPath}/api/GetAllSessionsData`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": hostHeader,
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error("Failed to fetch parking overview");
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching parking overview:", error);
            throw error;
        }
    };

    export const fetchBankDetailsByEntity = async (id) => {
        try {
            if (!id) return [];

            const response = await fetch(
                `${hostPath}/api/UpdateBankDetails/${id}?isEmployee=false`,
                {
                    method: "GET",
                    headers: {
                        "x-functions-key": hostHeader,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Bank fetch failed");
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching bank details:", error);
            throw error;
        }
    };




